
import Vue from 'vue';

export default Vue.extend({
  name: 'UiSwitch',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateValue(val: string) {
      this.$emit('input', val)
    }
  }
})
